<template>
  <div class="xml-content">
    <footer class="footer" v-html="footerXml"></footer>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import $ from "jquery";
import axios from "axios";
@Component
export default class ComponentName extends Vue {
  get footerXml() {
    return this.$store.state.footerXml;
  }
  mounted() {
    //   this.api.getFooterHeader().then(res => {
    //     this.footerXml = res.footer
    //        this.handleFooterJs()
    // })
    // axios
    //   .get(
    //     `https://sophon.cn/html/get-header-footer-html.html?locale=CN&type=mobile&isGuest=true&serviceDomain=&active=`
    //   )
    //   .then(res => {
    //     this.footerXml = res.data["footer"];
    //     this.handleFooterJs();
    //   });

    /*kf5 ticket link*/
    setTimeout(() => {
      $(".ticket-button").click(function () {
        $("#kf5-support-btn").click();
      });

      /*zendesk ticket link*/
      $(".ticket-button-en").click(function () {
        $('.zopim[data-test-id="ChatWidgetButton"]').css("display", "none");
        $('.zopim[data-test-id="ChatWidgetWindow"]').css("display", "block");
      });
    }, 1000);
    if (location.host.endsWith("sophnet.com")) {
      setTimeout(() => {
        this.updateCopyright();
      }, 10);
    }
  }
  updated() {
    this.handleFooterJs();
  }
  handleFooterJs() {
    const windowWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    $("footer").on("click", ".mobile-click-item", function (e) {
      const dataTarget = $(this).attr("data-target");
      const $waitActiveEle = $(`#${dataTarget}`);
      if (
        windowWidth < 768 &&
        $waitActiveEle.length &&
        !e.target.classList.contains("mobile-click-box-cancle") &&
        !e.target.classList.contains("cancle-svg")
      ) {
        if (!$waitActiveEle[0].classList.contains("active")) {
          $(".mobile-click-box").removeClass("active");
          $waitActiveEle.addClass("active");
        } else {
          $(".mobile-click-box").removeClass("active");
        }
      }
    });

    $("body").on("click", function (e) {
      if (
        $(e.target).hasClass("mobile-click-item") ||
        $(e.target).hasClass("mobile-click-box") ||
        $(e.target).closest(".mobile-click-item").length > 0 ||
        $(e.target).closest(".mobile-click-box").length > 0 ||
        windowWidth >= 768
      ) {
        return;
      }
      $(".mobile-click-box").removeClass("active");
    });

    $("footer").on("click", ".mobile-click-box-cancle", function () {
      $(".mobile-click-box").removeClass("active");
    });

    $("footer").on("click", ".cancle-svg", function () {
      $(".mobile-click-box").removeClass("active");
    });
    $("footer").on("mouseenter", ".customer-hover-action", function () {
      if (windowWidth <= 768) {
        return;
      }
      var dataTarget = $(this).attr("data-target");
      if (dataTarget && dataTarget.length > 0) {
        $(`#${dataTarget}`).show();
      }
    });

    $("footer").on("mouseleave", ".customer-hover-action", function () {
      if (windowWidth <= 768) {
        return;
      }
      var dataTarget = $(this).attr("data-target");
      if (dataTarget && dataTarget.length > 0) {
        $(`#${dataTarget}`).hide();
      }
    });

    $("footer").on("click", ".customer-hover-close-icon", function () {
      var dataTarget = $(this).attr("data-target");
      if (dataTarget && dataTarget.length > 0) {
        $(`#${dataTarget}`).hide();
      }
    });

    $("footer").on("click", ".customer-hover-action", function (e) {
      if (
        e.target.classList.contains("customer-hover-close-icon") ||
        $(e.target).closest(".customer-hover-box").length > 0
      ) {
        return;
      }
      var dataTarget = $(this).attr("data-target");
      var $currentEle = $(`#${dataTarget}`);
      if (dataTarget && dataTarget.length > 0) {
        if ($currentEle.css("display") === "block") {
          $currentEle.hide();
        } else {
          $currentEle.show();
        }
      }
    });
    // 新增先隐藏
    const $footerFollowLine = $(".footer-follow-line");
    const $footerLineCorner = $(".footer-line-corner");
    const $wechatIcon = $(".footer-first-icon");
    const $douyinIcon = $(".footer-second-icon");
    const $bilibiliIcon = $(".footer-third-icon");
    const $weiboIcon = $(".footer-fourth-icon");
    const $videoIcon = $(".footer-fifth-icon");
    const $toutiaoIcon = $(".footer-sixth-icon");
    function showFooterLine(index) {
      if (index === 0) {
        $footerLineCorner.css("left", "2px");
        $(".footer-first-qr").css("display", "flex");
      } else if (index === 1) {
        $footerLineCorner.css("left", "28px");
        $(".footer-second-qr").css("display", "flex");
      } else if (index === 2) {
        $footerLineCorner.css("left", "58px");
        $(".footer-third-qr").css("display", "flex");
      } else if (index === 3) {
        $footerLineCorner.css("left", "84px");
        $(".footer-fourth-qr").css("display", "flex");
      } else if (index === 4) {
        $footerLineCorner.css("left", "115px");
        $(".footer-fifth-qr").css("display", "flex");
      } else if (index === 5) {
        $footerLineCorner.css("left", "142px");
        $(".footer-sixth-qr").css("display", "flex");
      }

      if (index !== 0) {
        $(".footer-first-qr").css("display", "none");
      }
      $footerFollowLine.css("display", "block");
      $footerLineCorner.css("display", "inline-block");
    }

    function hideFooterLine(index) {
      if (index === 0) {
        $(".footer-first-qr").css("display", "none");
      } else if (index === 1) {
        $(".footer-second-qr").css("display", "none");
      } else if (index === 2) {
        $(".footer-third-qr").css("display", "none");
      } else if (index === 3) {
        $(".footer-fourth-qr").css("display", "none");
      } else if (index === 4) {
        $(".footer-fifth-qr").css("display", "none");
      } else if (index === 5) {
        $(".footer-sixth-qr").css("display", "none");
      }
      $footerFollowLine.css("display", "none");
      $footerLineCorner.css("display", "none");
    }

    $wechatIcon.mouseenter(function () {
      showFooterLine(0);
    });

    $wechatIcon.mouseleave(function () {
      hideFooterLine(0);
    });

    $douyinIcon.mouseenter(function () {
      showFooterLine(1);
    });

    $douyinIcon.mouseleave(function () {
      hideFooterLine(1);
    });

    $bilibiliIcon.mouseenter(function () {
      showFooterLine(2);
    });

    $bilibiliIcon.mouseleave(function () {
      hideFooterLine(2);
    });

    $weiboIcon.mouseenter(function () {
      showFooterLine(3);
    });

    $weiboIcon.mouseleave(function () {
      hideFooterLine(3);
    });

    $videoIcon.mouseenter(function () {
      showFooterLine(4);
    });

    $videoIcon.mouseleave(function () {
      hideFooterLine(4);
    });

    $toutiaoIcon.mouseenter(function () {
      showFooterLine(5);
    });

    $toutiaoIcon.mouseleave(function () {
      hideFooterLine(5);
    });

    $(".footer-icons-container").mouseleave(function () {
      showFooterLine(0);
    });
    // 新增隐藏最底部
  }
  updateCopyright() {
    const footer = document.querySelector(".footer-copyright-inside");
    const img = require("../assets/copyright.png");
    const copyrightHtml = `
      <div>
        Copyright © 算能 | 
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP备 2020046167号-3</a> | 
        <img src="${img}" />
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11030102011330" target="_blank">京公网安备 11030102011330号</a>
      </div>
    `;
    footer && (footer.innerHTML = copyrightHtml);
  }
}
</script>

<style lang="scss" scoped></style>
